import axios from 'axios'
import { useMemo } from 'react'
import { useAppSelector } from '../../application/states/hooks'
import { useEndSession } from '../../use-cases/authentication/useEndSession'

// Mensagem amigável conforme o motivo do 401 informado pelo backend
const getSessionEndedMessage = (backendMessage?: string) => {
  if (backendMessage?.toLowerCase().includes('inativo')) {
    return 'Seu acesso foi desativado. Procure o administrador da sua empresa.'
  }
  return 'Sua sessão expirou. Faça login novamente.'
}

export const useAxiosInstances = () => {
  const authState = useAppSelector((state) => state.auth)
  const { resaleConfig } = useAppSelector((state) => state.resaleConfig)
  const { endSession } = useEndSession()

  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: resaleConfig?.domainBackEnd ?`https://${resaleConfig.domainBackEnd}`: process.env.REACT_APP_BASE_URL,      

    })
  }, [resaleConfig?.domainBackEnd])
  
  const axiosAuthInstance = useMemo(() => {
    const instance = axios.create({
      headers: {
        Authorization: `bearer ${authState.token}`,
        'x-origin-domain': window.location.host
      },
      baseURL: resaleConfig?.domainBackEnd ?`https://${resaleConfig.domainBackEnd}`: process.env.REACT_APP_BASE_URL,      
      timeout: Number(process.env.AXIOS_TIMEOUT ?? 0)
    })
    

    instance.interceptors.response.use((response) => {

      return response
    },
       (error) => {
        // Sessão encerrada (usuário inativo, sessão revogada ou token expirado)
        if (error?.response?.status === 401) {
          endSession(getSessionEndedMessage(error?.response?.data?.message))
        }
        return Promise.reject(error)
      }
    )
    return instance
  }, [authState.token, resaleConfig?.domainBackEnd, endSession])
  return {
    axiosInstance,
    axiosAuthInstance
  }
}